export default "__VITE_ASSET__B9UBi$Fb__"